// © Copyright 2026 Emman Consulting SAS
import React, { useState } from "react";
import { FWC } from "../../data/albumData.js";
import { I18N } from "../../i18n.js";
import { useLongPress } from "../../hooks/useLongPress.js";

const FwcSection = React.memo(function FwcSection({ col, onTap, onReset, filter, onModal, lang }) {
  const t = I18N[lang || "es"];
  const [open, setOpen] = useState(false);
  const owned = FWC.filter((s) => col[s.code]?.owned).length;
  const pct = Math.round(owned / 19 * 100);
  const { handlers } = useLongPress({ onTap, onReset });

  return (
    <div className="fwcbox">
      <div className="fwchdr" onClick={() => setOpen((o) => !o)}>
        <div className="fwchl" style={{ gap: 10 }}>
          <div className="fwc-badge" onClick={(e) => { e.stopPropagation(); onModal(); }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/>
              <path d="M12 7l4.76 3.45l-1.76 5.55h-6l-1.76 -5.55l4.76 -3.45"/>
              <path d="M12 7v-4m3 13l2.5 3m-.74 -8.55l3.74 -1.45m-11.44 7.05l-2.56 2.95m.74 -8.55l-3.74 -1.45"/>
            </svg>
          </div>
          <div>
            <div className="fwcttl">{t.fwcTitle}</div>
            <div className="fwcsub">{t.fwcSub}</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ textAlign: "right" }}>
            <span className="fwcpill">{pct}%</span>
            <div className="gcnt">{owned}/19</div>
          </div>
          <span className={"chv" + (open ? " open" : "")}>▼</span>
        </div>
      </div>
      {open && (
        <div className="sdots" style={{ padding: 16 }}>
          {FWC.map((s) => {
            const st = col[s.code] || { owned: false, quantity: 0 };
            const isDupe = st.owned && st.quantity > 0;
            const numMatch = s.code.match(/FWC\s*(\d+)/);
            const numStr = numMatch ? numMatch[1] : s.code;
            if (filter === "missing" && st.owned) return null;
            if (filter === "dupes" && st.quantity === 0) return null;
            return (
              <div
                key={s.code}
                className={"sdot-fwc" + (isDupe ? " dupe" : st.owned ? " owned" : "")}
                data-qty={isDupe ? "×" + st.quantity : ""}
                data-num={numStr}
                title={s.label}
                {...handlers(s.code)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
});

export default FwcSection;
